import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Separator from '../../separator';
import { changeCurrentPage } from '../../../general_redux/actions';

import candy from '../../../icons/dot.svg';
import buttonStyles from '../topbar.module.scss';
import Menu from './Menu';

function Menu1({ menuItems, currentModule, location: { pathname }, actionUpdateCurrentPage }) {
  const [menuDrop, setMenuDrop] = useState(false);
  const menuIconRef = useRef();
  useEffect(() => {
    const handleClickOutsideIcon = (e) => {
      if (menuIconRef.current && !menuIconRef.current.contains(e.target)) {
        setMenuDrop(false);
      }
    };
    if (menuDrop) {
      document.addEventListener('click', handleClickOutsideIcon, false);
    }
    return () => {
      document.removeEventListener('click', handleClickOutsideIcon, false);
    };
  }, [menuDrop]);

  useEffect(() => {
    const subMenuItems = [
      { id: 'topbar.menu.home', name: 'Home', pathname: '/' },
      { id: 'todo.my_tasks', name: 'My Tasks', pathname: '/my_tasks' },
      { id: 'todo.completed_tasks', name: 'Completed Tasks', pathname: '/completed_tasks' },

      { id: 'topbar.Manage_Gates', name: 'Manage Gates', pathname: '/gateManagement' },
      { id: 'topbar.gate_allocation', name: 'Gate Allocation', pathname: '/gate_allocation' },
      { id: 'topbar.gate_change', name: 'Gate Change Request', pathname: '/gate_change' },

      { id: 'topbar.menu.work.orders', name: 'Work Orders', pathname: '/maintenance' },

      { id: 'topbar.Documents', name: 'Lease Documents', pathname: '/document' },
      { id: 'topbar.shared_doc', name: 'Shared Documents', pathname: '/documents' },

      { id: 'topbar.Badging', name: 'Badging', pathname: '/badging/List' },
      { id: 'topbar.inspections', name: 'Inspections', pathname: '/myInspections' },
      { id: 'topbar.Safety_Promotions', name: 'Safety Promotions', pathname: '/sms/safety_promotion' },

      { id: 'topbar.My_Trainings', name: 'My Trainings', pathname: '/training' },

      { id: 'topbar.forms.library', name: 'Forms Library', pathname: '/myforms' },
      { id: 'topbar.submitted.forms', name: 'Submitted Forms', pathname: '/form-submissions' },
      { id: 'topbar.form.approvals', name: 'Form Approvals', pathname: '/form-approvals' },

      { id: ' ', name: menuItems.profile?.permit_management?.driver_permit || 'ADP', pathname: '/adp/logs' },
      { id: ' ', name: menuItems.profile?.permit_management?.vehicle_permit || 'AVP', pathname: '/avp/logs' },
      { id: 'topbar.menu.my.applications', name: 'My Applications', pathname: '/adp/myapplications' },
      {
        id: 'topbar.menu.permits.adp.defects',
        name: menuItems?.profile?.permit_management?.violations || 'Violations',
        pathname: '/adp/violations'
      },
      {
        id: 'topbar.menu.permits.avp.defects',
        name: menuItems?.profile?.permit_management?.vehicle_defect || 'Defects',
        pathname: '/avp/vehicle_defect'
      },
      {
        id: 'topbar.menu.permits.avp.voilations',
        name: menuItems?.profile?.permit_management?.violations || 'Violations',
        pathname: '/avp/violations'
      },
      {
        id: 'topbar.menu.permits.adp.voilations',
        name: menuItems?.profile?.permit_management?.vehicle_defect || 'Defects',
        pathname: '/adp/vehicle_defect'
      },

      { id: 'topbar.Invoices', name: 'Invoices', pathname: '/invoice' },
      { id: 'topbar.usage.fee.reporting', name: 'Usage & Fee Reporting', pathname: '/gross_receipts/list' }
    ];
    const currentPath = subMenuItems.find(s => s.pathname === pathname);
    if (currentPath) {
      actionUpdateCurrentPage(currentPath.name);
    } else {
      actionUpdateCurrentPage('Airport Portal');
    }
  }, [pathname, actionUpdateCurrentPage, menuItems]);


  const handleIconClick = () => {
    setMenuDrop(!menuDrop);
  };
  return (
    <>
      <Separator />
      <div className={buttonStyles.menuIcon}>
        <button className={buttonStyles.menuBtn} onClick={handleIconClick} type="button" ref={menuIconRef}>
          <img src={candy} alt="menu" width="24px" style={{ filter: 'invert(100%)' }} />
          <FormattedMessage id={currentModule?`topbar.${currentModule}`: 'topbar.no_id'}
            defaultMessage={currentModule?.replaceAll('_', ' ')}
          />
        </button>

        {menuDrop && (
          <div ref={menuIconRef}>
            <Menu items={menuItems} handleIconClick={handleIconClick} />
          </div>
        )}
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  currentModule: state.general.currentModule,
  user: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionUpdateCurrentPage: (page) => {
    dispatch(changeCurrentPage(page));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Menu1));
